/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseOfString } from '../models/api-response-of-string';
import { Billing } from '../models/billing';
import { BillingDto } from '../models/billing-dto';
import { billingGetallfacilityphysandreferrings } from '../fn/billing/billing-getallfacilityphysandreferrings';
import { BillingGetallfacilityphysandreferrings$Params } from '../fn/billing/billing-getallfacilityphysandreferrings';
import { billingGetBillingList } from '../fn/billing/billing-get-billing-list';
import { BillingGetBillingList$Params } from '../fn/billing/billing-get-billing-list';
import { billingGetDetail } from '../fn/billing/billing-get-detail';
import { BillingGetDetail$Params } from '../fn/billing/billing-get-detail';
import { billingLoadProcedures } from '../fn/billing/billing-load-procedures';
import { BillingLoadProcedures$Params } from '../fn/billing/billing-load-procedures';
import { billingLoadrecentdiagnosis } from '../fn/billing/billing-loadrecentdiagnosis';
import { BillingLoadrecentdiagnosis$Params } from '../fn/billing/billing-loadrecentdiagnosis';
import { billingLoadsearchdiagnosis } from '../fn/billing/billing-loadsearchdiagnosis';
import { BillingLoadsearchdiagnosis$Params } from '../fn/billing/billing-loadsearchdiagnosis';
import { billingSearchprocedures } from '../fn/billing/billing-searchprocedures';
import { BillingSearchprocedures$Params } from '../fn/billing/billing-searchprocedures';
import { billingSubmitCharges } from '../fn/billing/billing-submit-charges';
import { BillingSubmitCharges$Params } from '../fn/billing/billing-submit-charges';
import { DataPageOfBilling } from '../models/data-page-of-billing';

@Injectable({ providedIn: 'root' })
export class BillingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `billingGetallfacilityphysandreferrings()` */
  static readonly BillingGetallfacilityphysandreferringsPath = '/providers/getallfacilityphysandreferrings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingGetallfacilityphysandreferrings()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingGetallfacilityphysandreferrings$Response(params?: BillingGetallfacilityphysandreferrings$Params, context?: HttpContext): Observable<StrictHttpResponse<BillingDto>> {
    return billingGetallfacilityphysandreferrings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingGetallfacilityphysandreferrings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingGetallfacilityphysandreferrings(params?: BillingGetallfacilityphysandreferrings$Params, context?: HttpContext): Observable<BillingDto> {
    return this.billingGetallfacilityphysandreferrings$Response(params, context).pipe(
      map((r: StrictHttpResponse<BillingDto>): BillingDto => r.body)
    );
  }

  /** Path part for operation `billingGetBillingList()` */
  static readonly BillingGetBillingListPath = '/billing/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingGetBillingList()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingGetBillingList$Response(params?: BillingGetBillingList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfBilling>> {
    return billingGetBillingList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingGetBillingList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingGetBillingList(params?: BillingGetBillingList$Params, context?: HttpContext): Observable<DataPageOfBilling> {
    return this.billingGetBillingList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfBilling>): DataPageOfBilling => r.body)
    );
  }

  /** Path part for operation `billingLoadProcedures()` */
  static readonly BillingLoadProceduresPath = '/billing/LoadProcedures';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingLoadProcedures()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingLoadProcedures$Response(params?: BillingLoadProcedures$Params, context?: HttpContext): Observable<StrictHttpResponse<Billing>> {
    return billingLoadProcedures(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingLoadProcedures$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingLoadProcedures(params?: BillingLoadProcedures$Params, context?: HttpContext): Observable<Billing> {
    return this.billingLoadProcedures$Response(params, context).pipe(
      map((r: StrictHttpResponse<Billing>): Billing => r.body)
    );
  }

  /** Path part for operation `billingLoadrecentdiagnosis()` */
  static readonly BillingLoadrecentdiagnosisPath = '/billing/recentdiagnosis';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingLoadrecentdiagnosis()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingLoadrecentdiagnosis$Response(params?: BillingLoadrecentdiagnosis$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfBilling>> {
    return billingLoadrecentdiagnosis(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingLoadrecentdiagnosis$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingLoadrecentdiagnosis(params?: BillingLoadrecentdiagnosis$Params, context?: HttpContext): Observable<DataPageOfBilling> {
    return this.billingLoadrecentdiagnosis$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfBilling>): DataPageOfBilling => r.body)
    );
  }

  /** Path part for operation `billingLoadsearchdiagnosis()` */
  static readonly BillingLoadsearchdiagnosisPath = '/billing/searchdiagnosis';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingLoadsearchdiagnosis()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingLoadsearchdiagnosis$Response(params?: BillingLoadsearchdiagnosis$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfBilling>> {
    return billingLoadsearchdiagnosis(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingLoadsearchdiagnosis$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingLoadsearchdiagnosis(params?: BillingLoadsearchdiagnosis$Params, context?: HttpContext): Observable<DataPageOfBilling> {
    return this.billingLoadsearchdiagnosis$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfBilling>): DataPageOfBilling => r.body)
    );
  }

  /** Path part for operation `billingSubmitCharges()` */
  static readonly BillingSubmitChargesPath = '/billing/submitcharges';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingSubmitCharges()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  billingSubmitCharges$Response(params: BillingSubmitCharges$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
    return billingSubmitCharges(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingSubmitCharges$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  billingSubmitCharges(params: BillingSubmitCharges$Params, context?: HttpContext): Observable<ApiResponseOfString> {
    return this.billingSubmitCharges$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOfString>): ApiResponseOfString => r.body)
    );
  }

  /** Path part for operation `billingSearchprocedures()` */
  static readonly BillingSearchproceduresPath = '/billing/searchprocedures';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingSearchprocedures()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingSearchprocedures$Response(params?: BillingSearchprocedures$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfBilling>> {
    return billingSearchprocedures(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingSearchprocedures$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingSearchprocedures(params?: BillingSearchprocedures$Params, context?: HttpContext): Observable<DataPageOfBilling> {
    return this.billingSearchprocedures$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfBilling>): DataPageOfBilling => r.body)
    );
  }

  /** Path part for operation `billingGetDetail()` */
  static readonly BillingGetDetailPath = '/billing/getdetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingGetDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingGetDetail$Response(params?: BillingGetDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Billing>>> {
    return billingGetDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingGetDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingGetDetail(params?: BillingGetDetail$Params, context?: HttpContext): Observable<Array<Billing>> {
    return this.billingGetDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Billing>>): Array<Billing> => r.body)
    );
  }

}
